<template>
    <div class="card-body">
        <div class="row text-left mb-3">
            <div class="col-sm-12 mb-2">
                <p class="h4"><button @click="goBack()" class="btn btn-link mr-2"><i class="fa fa-arrow-left"></i> {{ __('payments.Change Plan') }}</button> {{ __('payments.Select Method') }}</p>
            </div>
        </div>
        <div class="row payment_buttons">
            <div class="col-sm-4">
                <button @click="setMethod('paypal')" type="button" class="btn btn-lg btn-light btn-block">
                    <img src="/img/paypal.png" alt="" />
                </button>
            </div>
            <!-- <div class="col-sm-3">
                <button @click="setMethod('wirecard')" type="button" class="btn btn-lg btn-light btn-block">
                    <img src="/img/wirecard.png" alt="" />
                </button>
            </div> -->
            <div class="col-sm-4">
                <button @click="setMethod('neteller')" type="button" class="btn btn-lg btn-light btn-block">
                    <img src="/img/neteller_logo.png" alt="" />
                </button>
            </div>
            <div class="col-sm-4">
                <button @click="setMethod('skrill')" type="button" class="btn btn-lg btn-light btn-block">
                    <img src="/img/skrill_logo.png" alt="" />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {}
    },
    methods: {
        goBack() {
            this.$emit('goBack');
        },
        setMethod(method) {
            this.$emit('setMethod', method);
        }
    }
}
</script>

<style lang="scss">
    .payment_buttons {
        button {
            height: 156px;
        }

        img {
            max-width: 100%;
        }
    }
</style>
